/**
 * Horizon theme detection utility
 */

/**
 * Check if the current theme is Horizon (or Horizon variants like "Horizon v2")
 * @returns boolean - true if current theme is Horizon or Horizon variant
 */
export const isHorizonTheme = (): boolean => {
  const shopifyTheme = (window as any)?.Shopify?.theme;

  if (!shopifyTheme) {
    return false;
  }

  const themeName = shopifyTheme.name?.toLowerCase() || '';
  const schemaName = shopifyTheme.schema_name?.toLowerCase() || '';

  return themeName.includes('horizon') || schemaName.includes('horizon');
};

/**
 * Get current theme information for debugging
 * @returns object with theme details or null if not available
 */
export const getCurrentTheme = () => {
  return (window as any)?.Shopify?.theme || null;
};
